var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitor-calls" } },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c("div", { staticClass: "calls-header" }, [
            _c("div", { staticClass: "header-info" }, [
              _c("div", { staticClass: "visitor-phone" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("phone")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.getDisplayPhoneNumber()))]),
              ]),
              _vm._v(" "),
              _vm.callRecords.length > 0
                ? _c("div", { staticClass: "total-calls" }, [
                    _c("span", { staticClass: "count" }, [
                      _vm._v(_vm._s(_vm.callRecords.length)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label" }, [
                      _vm._v("toplam arama"),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.providers.length > 0
                ? _c(
                    "div",
                    { staticClass: "providers-info" },
                    [
                      _c("span", { staticClass: "providers-label" }, [
                        _vm._v("Sağlayıcılar:"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.providers, function (provider) {
                        return _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: { content: provider.count + " arama" },
                                expression:
                                  "{ content: `${provider.count} arama` }",
                              },
                            ],
                            key: provider.type,
                            staticClass: "provider-badge",
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(provider.name) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.callRecords.length > 0
            ? _c("div", { staticClass: "quick-stats" }, [
                _c("div", { staticClass: "stat-item incoming" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("call_received"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-number" }, [
                      _vm._v(_vm._s(_vm.incomingCalls)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [_vm._v("Gelen")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-item outgoing" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("call_made"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-number" }, [
                      _vm._v(_vm._s(_vm.outgoingCalls)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [_vm._v("Giden")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-item answered" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("check_circle"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-number" }, [
                      _vm._v(_vm._s(_vm.answeredCalls)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("Cevaplanmış"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-item total-duration" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("schedule"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-number" }, [
                      _vm._v(_vm._s(_vm.totalDurationText)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("Toplam Süre"),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "calls-content" }, [
            _vm.callRecords.length === 0 && !_vm.loading
              ? _c("div", { staticClass: "empty-state" }, [
                  _c("div", { staticClass: "empty-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("call_received"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "empty-text" }, [
                    _vm._v("Bu kişi ile henüz arama kaydı bulunamadı"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "empty-subtitle" }, [
                    _vm._v(
                      "Tüm webphone sağlayıcılarında son 12 aydaki aramalar kontrol edildi"
                    ),
                  ]),
                ])
              : _c(
                  "div",
                  { staticClass: "calls-list" },
                  _vm._l(_vm.callRecords, function (call) {
                    return _c(
                      "div",
                      {
                        key: call.uniqueid,
                        staticClass: "call-item",
                        class: _vm.getCallItemClass(call),
                      },
                      [
                        _c("div", { staticClass: "call-direction" }, [
                          _c(
                            "div",
                            {
                              staticClass: "direction-icon",
                              class: call.direction.toLowerCase(),
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      call.direction === "INBOUND"
                                        ? "call_received"
                                        : "call_made"
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "call-info" }, [
                          _c("div", { staticClass: "call-primary" }, [
                            _c("div", { staticClass: "call-number-info" }, [
                              _c("span", { staticClass: "other-number" }, [
                                _vm._v(_vm._s(_vm.getOtherNumber(call))),
                              ]),
                              _vm._v(" "),
                              _vm.getCallAgent(call)
                                ? _c("span", { staticClass: "call-agent" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.getCallAgent(call)) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              call.provider
                                ? _c("span", { staticClass: "call-provider" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(call.provider) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "call-status",
                                class: call.status.toLowerCase(),
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.getStatusText(call.status)) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "call-secondary" }, [
                            _c("div", { staticClass: "call-time" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.formatCallDate(call.calldate)) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            call.billsec > 0
                              ? _c("div", { staticClass: "call-duration" }, [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("schedule"),
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.formatDuration(call.billsec)) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "call-actions" }, [
                          call.recordingfile && call.recordurl
                            ? _c(
                                "button",
                                {
                                  staticClass: "action-btn play-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.playRecording(call)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("play_circle"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "action-btn info-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.showCallDetails(call)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("info"),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
          ]),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: { title: "Arama Detayları", footer: null, width: "600px" },
              model: {
                value: _vm.showDetailModal,
                callback: function ($$v) {
                  _vm.showDetailModal = $$v
                },
                expression: "showDetailModal",
              },
            },
            [
              _vm.selectedCall
                ? _c(
                    "div",
                    [
                      _c(
                        "a-descriptions",
                        { attrs: { column: 2, bordered: "", size: "small" } },
                        [
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "Tarih" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm
                                      .$moment(_vm.selectedCall.calldate)
                                      .format("DD.MM.YYYY HH:mm:ss")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "Yön" } },
                            [
                              _c(
                                "a-tag",
                                {
                                  attrs: {
                                    color: _vm.getDirectionColor(
                                      _vm.selectedCall.direction
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.getDirectionText(
                                          _vm.selectedCall.direction
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "Arayan" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.selectedCall.cli) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "Aranan" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.selectedCall.cld) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "Durum" } },
                            [
                              _c(
                                "a-tag",
                                {
                                  attrs: {
                                    color: _vm.getStatusColor(
                                      _vm.selectedCall.status
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.selectedCall.status) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "Supsis Kullanıcısı" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getCallAgent(_vm.selectedCall) ||
                                      "Bilinmiyor"
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "Toplam Süre" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.formatDuration(
                                      _vm.selectedCall.duration
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "Konuşma Süresi" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.formatDuration(_vm.selectedCall.billsec)
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "CDR ID", span: "2" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.selectedCall.cdrid) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-descriptions-item",
                            { attrs: { label: "Unique ID", span: "2" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.selectedCall.uniqueid) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.showAudioPlayer
            ? _c("div", { staticClass: "audio-player-dock" }, [
                _c("div", { staticClass: "audio-player-container" }, [
                  _c("div", { staticClass: "audio-player-info" }, [
                    _c("i", { staticClass: "material-icons audio-icon" }, [
                      _vm._v("music_note"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "audio-title" }, [
                      _vm._v(_vm._s(_vm.currentPlayingRecordName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "audio-player-wrapper" }, [
                    _c("audio", {
                      ref: "audioPlayer",
                      attrs: {
                        controls: "",
                        src: _vm.currentPlayingRecordURL,
                        autoplay: "",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "audio-player-controls" },
                    [
                      _c("a-button", {
                        attrs: {
                          type: "danger",
                          shape: "circle",
                          icon: "close",
                        },
                        on: { click: _vm.closeAudioPlayer },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }